import { render, staticRenderFns } from "./DeskLights.vue?vue&type=template&id=1a4cadaf"
import script from "./DeskLights.vue?vue&type=script&lang=js"
export * from "./DeskLights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports